<template>
    <div class="box">
        <el-row>
            <el-col :span="24">
                <div class="block">
                    <span class="welcome" style="color: red;margin-right: 5px">{{userInfo.name}}</span> 您好！欢迎使用沃尔核材招聘系统!
                    当前时间：{{new Date() | fmtDate}}
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as c from '@/util/config'
    import * as u from '@/util/util'
    import {mapActions} from 'vuex'

    export default {
        name: "csy",
        data() {
            return {
                //用户信息
                userInfo: u.getSession(c.sessionKey.USER_INFO),
            }
        },

        methods: {

        }
    }
</script>

<style scoped lang="scss">
    .box {
        max-width: 100%;
        min-height: 100%;

        .block {
            margin-bottom: 20px;
            padding: 15px 0;
            background: #f2f2f2;
            color: #140000;

            span {
                margin-left: 20px;
            }

        }

    }


</style>
